import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { localPersistStorage } from "~/lib/persist-storage";
import { ResceduleAppointmentData } from "../api/types";
import { RescheduleAppointmentSchemaData } from "../schemas";

type AppointmentFormType = RescheduleAppointmentSchemaData & {
  date: Date;
  time: string;
  timeZone: string;
  message: string;
};

type FormType = {
  step: number;
  data: AppointmentFormType;
  appointment: ResceduleAppointmentData;
  setStep: (newStep: number) => void;
  setAppointmentForm: (data: AppointmentFormType) => void;
  setAppointment: (data: ResceduleAppointmentData) => void;
  clearForm: () => void;
};

const initialState = {
  step: 1,
  data: {} as AppointmentFormType,
  appointment: {} as ResceduleAppointmentData,
};

export const useRescheduleAppointmentFormStore = create<FormType>()(
  persist(
    (set) => ({
      ...initialState,
      setStep: (newStep) => set({ step: newStep }),
      setAppointmentForm: (data) => set({ data }),
      setAppointment: (data) => set({ appointment: data }),
      clearForm: () => set({ ...initialState }),
    }),
    {
      name: "appointment-form-storage",
      storage: createJSONStorage(() => localPersistStorage),
    },
  ),
);


